import React from 'react'
import { Outlet } from 'react-router-dom'

export const OemBase: React.FC = () => {
  return <Outlet />
}
